var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('section',{staticClass:"info-footer-row-container"},[_c('div',{staticClass:"info-footer-row"},[_c('h4',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('home.row-info-footer')))]),_c('join-us-button')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }